import {
  IGlobalConfigurationFields,
  IPartnerPageConfigurationFields
} from '@/types/contentful';
import { isPartnerPageSlug } from './partnerPageSlugs';

interface GetPartnerPageContentProps {
  slug: string;
  globalConfig: IGlobalConfigurationFields | undefined;
  partnerPageConfig: IPartnerPageConfigurationFields | undefined;
}

/**
 * Get the appropriate header content for a page
 * If it's a partner page and partner configuration exists, use partner header, otherwise fall back to global header
 */
export const getPartnerPageHeader = ({
  slug,
  globalConfig,
  partnerPageConfig
}: GetPartnerPageContentProps) => {
  const isPartnerPage = isPartnerPageSlug(slug);
  if (isPartnerPage && partnerPageConfig) {
    return partnerPageConfig.header ?? globalConfig?.header;
  }

  return globalConfig?.header;
};

/**
 * Get the appropriate footer content for a page
 * If it's a partner page and partner configuration exists, use partner footer, otherwise fall back to global footer
 */
export const getPartnerPageFooter = ({
  slug,
  globalConfig,
  partnerPageConfig
}: GetPartnerPageContentProps) => {
  const isPartnerPage = isPartnerPageSlug(slug);

  if (isPartnerPage && partnerPageConfig) {
    return partnerPageConfig.footer ?? globalConfig?.footer;
  }

  return globalConfig?.footer;
};
